"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionGroup = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _RadioButton = require("../../elements/radio-button/RadioButton");
var _optionGroupModule = _interopRequireDefault(require("./option-group.module.scss"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Tooltip = require("../tooltip/Tooltip");
var _infoCircle = require("../../assets/icons/info-circle.svg");
var OptionGroup = function OptionGroup(_ref) {
  var description = _ref.description,
    options = _ref.options,
    onChange = _ref.onChange,
    optionsClassName = _ref.optionsClassName,
    value = _ref.value,
    className = _ref.className,
    disabled = _ref.disabled,
    descriptionVariant = _ref.descriptionVariant,
    tooltip = _ref.tooltip;
  var firstOptionKey = options.length ? options[0].key : undefined;
  var _useState = (0, _react.useState)(value || firstOptionKey),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedKey = _useState2[0],
    setSelectedKey = _useState2[1];
  (0, _react.useEffect)(function () {
    if (value !== selectedKey && value !== undefined) {
      setSelectedKey(value);
    }
  }, [value, selectedKey]);
  var onSelectedChange = (0, _react.useCallback)(function (key) {
    setSelectedKey(key);
    onChange(key);
  }, [setSelectedKey, onChange]);
  var getDisabled = function getDisabled(option) {
    if (disabled) {
      return true;
    } else if (option.disabled) {
      return true;
    }
    return false;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames2.default)(_optionGroupModule.default['option-group__description'], (0, _defineProperty2.default)({}, _optionGroupModule.default['option-group__description--big'], descriptionVariant === 'big'))
  }, description, tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    size: "medium",
    title: tooltip,
    variant: "light",
    position: "bottom"
  }, /*#__PURE__*/_react.default.createElement(_infoCircle.ReactComponent, {
    className: _optionGroupModule.default['tooltip-icon'],
    "data-testid": "tooltip-icon"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_optionGroupModule.default['option-group__options-container'], optionsClassName),
    "data-testid": "options-container"
  }, options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_RadioButton.RadioButton, {
      transparent: true,
      id: o.key,
      className: _optionGroupModule.default['option-group__option'],
      onChange: function onChange() {
        return onSelectedChange(o.key);
      },
      description: o.description,
      name: o.key,
      value: o.key,
      key: o.key,
      label: o.label,
      checked: selectedKey === o.key,
      disabled: getDisabled(o),
      tooltip: o.tooltip
    }, o.children);
  })));
};
exports.OptionGroup = OptionGroup;